import type { SVGProps } from 'react';

const SvgCriclePlusLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z'
      stroke='currentColor'
      strokeLinejoin='round'
    />
    <path d='M12 9V15' stroke='currentColor' strokeLinecap='round' />
    <path d='M15 12H9' stroke='currentColor' strokeLinecap='round' />
  </svg>
);
export default SvgCriclePlusLt;
